// Full-page center detail. Clicking a row in CentersTab navigates here so the
// admin gets the whole main content area (no cramped dropdown), sidebar stays.
import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Eye } from 'lucide-react';
import { toast } from 'sonner';

import AppShell from '@/components/AppShell';
import { Button } from '@/components/ui/button';
import CenterDetail from '@/components/admin/CenterDetail';
import { useApp } from '@/lib/store';

export default function AdminCenter() {
  const { orgId } = useParams();
  const { startImpersonation } = useApp();
  const navigate = useNavigate();
  const [busy, setBusy] = React.useState(false);

  const viewAs = async () => {
    setBusy(true);
    try {
      await startImpersonation(orgId);
      toast.success('You are now viewing this center as its admin.');
      navigate('/org');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not enter center view.');
    } finally { setBusy(false); }
  };

  return (
    <AppShell>
      <div className="mx-auto max-w-6xl">
        <div className="border-b border-slate-200 pb-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <Link to="/admin" className="inline-flex items-center gap-1 text-sm font-medium text-slate-500 hover:text-slate-900" data-testid="back-to-centers">
              <ArrowLeft className="h-3.5 w-3.5" /> All centers
            </Link>
            <Button
              size="sm"
              onClick={viewAs}
              disabled={busy}
              data-testid="view-as-center-btn"
              className="gap-1 bg-slate-900 text-white hover:bg-slate-800"
            >
              <Eye className="h-3.5 w-3.5" />
              {busy ? 'Entering…' : 'View as this center'}
            </Button>
          </div>
          <h1 className="h-display mt-2 text-3xl sm:text-4xl">Center detail</h1>
          <p className="mt-1 text-sm text-slate-500">Full drill-down for this organisation — admin, students, instructors, limits, features, live activity, access controls.</p>
        </div>
        <CenterDetail orgId={orgId} />
      </div>
    </AppShell>
  );
}
